module.exports = __webpack_public_path__ + "static/media/m13tj93.00996f01.png";